//OK
import React, { Component } from 'react';
import {Provider} from 'react-redux'
import configureStore from './configureStore'
import Dashboard from './containers/cont_Dashboard';
import Nav from './containers/cont_Nav';
import * as util from './utils/styled';
import './styles/w3.css';
import 'font-awesome/css/font-awesome.min.css';
import './App.css';

const store = configureStore()

class App extends Component {
  constructor(props){
  super(props)
  console.log('constructor', this.props);
  }

  componentDidMount(){
    console.log('didMount', this.props);
  }

  componentDidUpdate(prevProps, prevState){
    console.log('didUpdate', this.props);
  }
  
  render() {
    console.log('app', this.props);
    return (
      <Provider store={store}>
        <util.Wrapper>
          <util.SideMenu>
            <Nav />
          </util.SideMenu>
          <util.Content>
            <Dashboard />
          </util.Content>
        </util.Wrapper>
      </Provider>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js